import vars from "../_vars.js";
const { forms } = vars;

if (forms) {
  forms.forEach((form) => {
    const ratingStars = form.querySelectorAll(".rating__star");
    const ratingInput = form.querySelector('input[name="rating"]');
    const textFields = form.querySelectorAll("input, textarea");
    const icons = form.querySelectorAll(".main-form__icon");

    textFields.forEach((field) => {
  const wrapper = field.closest(".main-form__label");

  const checkComplete = () => {
    if (field.value.trim()) {
      field.classList.add("complete");
    } else {
      field.classList.remove("complete");
    }
  };

  const removeIsWritingIfClickedOutside = (e) => {
    if (!wrapper.contains(e.target)) {
      field.classList.remove("is-writing");
      document.removeEventListener("click", removeIsWritingIfClickedOutside);
      checkComplete(); // проверка заполненности при потере is-writing
    }
  };

  field.addEventListener("input", () => {
    field.classList.add("is-writing");
    field.classList.remove("complete"); // убираем complete при вводе
  });

  field.addEventListener("focus", () => {
    if (field.value.trim()) {
      field.classList.add("is-writing");
    }
    field.classList.remove("complete"); // убираем complete при фокусе
    document.addEventListener("click", removeIsWritingIfClickedOutside);
  });

  field.addEventListener("blur", () => {
    setTimeout(() => {
      const relatedTarget = document.activeElement;
      if (wrapper && wrapper.contains(relatedTarget)) return;

      field.classList.remove("is-writing");
      checkComplete(); // добавляем complete если нужно
    }, 0);
  });

  // на старте можно сразу поставить complete, если уже заполнено (например, из автозаполнения)
  checkComplete();
});


    if (ratingStars.length === 0 || !ratingInput) return;

    ratingStars.forEach((star) => {
      star.addEventListener("click", () => {
        const ratingValue = star.dataset.value;
        if (!ratingValue) return;

        ratingInput.value = ratingValue;

        ratingStars.forEach((s) => {
          if (s.dataset.value <= ratingValue) {
            s.classList.remove("none");
          } else {
            s.classList.add("none");
          }
        });
      });
    });
  });
}
